/**
 * Weight in pounds, from a number typed in pounds or kilograms (Alan, 2026-10-01: "这个
 * weight要可以转换kg和lb", "单个的录入do也需要有kg和lb转换的选项"). Containers store pounds
 * only; a kilogram figure is converted on the way in and never stored as kilograms.
 *
 * A unit written after the number ("20000 kg", "44092lb", "9000公斤", "磅") wins over the
 * unit the form is set to, so a pasted column that mixes the two still reads right.
 */
export const POUNDS_PER_KILOGRAM = 2.2046226218;
const MAX_POUNDS = 1_000_000;

export function weightToPounds(raw, unit = 'lb') {
  const text = String(raw ?? '').replace(/ /g, ' ').replace(/,/g, '').trim();
  if (!text) return { value: null };
  const match = /^(\d+(?:\.\d+)?)\s*(kgs?|公斤|千克|lbs?|磅)?$/iu.exec(text);
  if (!match) return { error: true };
  const amount = Number(match[1]);
  const written = match[2] ? match[2].toLowerCase() : '';
  const kilograms = written ? /^(kg|公斤|千克)/u.test(written) : String(unit).toLowerCase() === 'kg';
  const pounds = kilograms ? Math.round(amount * POUNDS_PER_KILOGRAM) : amount;
  if (!(pounds > 0) || pounds > MAX_POUNDS) return { error: true };
  return kilograms
    ? { value: pounds, converted: true, from: `${match[1]} kg` }
    : { value: pounds, converted: false };
}
